import { createModel } from '@rematch/core';
import { getAnalyticsAppInsights } from '../../ApplicationInsights/AnalyticsTelemetry';

type AnalyticsRootState = {
  quote: { id: string };
};
type AnalyticsEvent = {
  eventType: string;
  eventProperties?: Record<string, unknown>;
};

// Product analytics for Order Acceptance. Previously dual-sent to Amplitude and
// Application Insights; Amplitude has been decommissioned (AQ8FES-5785) so App
// Insights is now the only destination. The instance itself is initialized once in
// App.tsx, so there is no init/isInitialized state to track here.
const analytics = createModel({
  state: {},
  effects: {
    sendEvent(event: AnalyticsEvent, state: AnalyticsRootState): void {
      const eventProperties = {
        ...event.eventProperties,
        quoteId: state.quote.id
      };

      try {
        const appInsights = getAnalyticsAppInsights();
        if (appInsights) {
          appInsights.trackEvent({
            name: event.eventType,
            properties: eventProperties
          });
        }
      } catch {
        // Swallow: telemetry must never affect the user flow.
      }
    }
  }
});

export default analytics;
